import { render, staticRenderFns } from "./nftList.vue?vue&type=template&id=e1297f2e&scoped=true&"
import script from "./nftList.vue?vue&type=script&lang=js&"
export * from "./nftList.vue?vue&type=script&lang=js&"
import style0 from "./nftList.vue?vue&type=style&index=0&id=e1297f2e&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1297f2e",
  null
  
)

export default component.exports